<div class="vu-meter" [ngStyle]="{ 'left.px': index * 10}">
  <div class="indicator" #indicator>
    <div class="color-scale" [style.height.px]="VUHeight - 76"></div>
  </div>
</div>
